import { BRAND_BLING_OPTIONS } from '@root/joinroot.com/src/components/brand-bling';
import { TEXT_ALIGNMENT_OPTIONS } from '@root/joinroot.com/src/constants/constants';

export const RENTERS_ZIP_CODE_FORM = 'rentersZipCodeForm';
export const HOMEOWNERS_ZIP_CODE_FORM = 'homeownersZipCodeForm';
export const AUTO_ZIP_CODE_FORM = 'autoZipCodeForm';
export const CUSTOM_FORM = 'customForm';

export const HERO_CONSTANTS = {
  TEXT_ALIGNMENT_LABELS: {
    CENTER: TEXT_ALIGNMENT_OPTIONS.CENTER,
    LEFT_ALIGN: TEXT_ALIGNMENT_OPTIONS.LEFT,
  },
  IMAGE_OVERLAY_LABELS: {
    NONE: BRAND_BLING_OPTIONS.NONE,
    CARET: BRAND_BLING_OPTIONS.CARET,
    LARGE_ROOT_TEXT: BRAND_BLING_OPTIONS.WORDMARK,
    ROOT_LOGO: BRAND_BLING_OPTIONS.ICON,
  },
};
